import { CognitoUserPool } from 'amazon-cognito-identity-js'

const getPoolData = () => {
    console.log(window.location.hostname)
    if (window.location.hostname.includes('dev') || window.location.hostname.includes('localhost')){
        return {UserPoolId: 'us-west-2_VWMyonoi7',ClientId: '9ebmtded8ba4mlq35l307enl1'}        
    }
    if (window.location.hostname.includes('test')){
        return {UserPoolId: 'us-west-2_Xh9COYAXZ',ClientId: '5dl6g8hfm5nh8lt6qguedbqanh'}
    }
    if (window.location.hostname.includes('app')){
        return {UserPoolId: 'us-west-2_WOFVkO9hZ',ClientId: '1ja92hl3s0n6di13ja16siqotq'}
    }
}
const userPool = new CognitoUserPool(getPoolData())
export default userPool
